import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IntercomTariffCard from './tariffCard';
import Carousel from '@ertelecom/ui-react/components/carousel';
import Option from './Option';
import {
    ArrowWrapper,
    Counter,
    Dots,
    DotWrapper,
    LeftArrow,
    RightArrow,
    Slide,
    Wrapper,
} from '~/src/components/Internet/TariffList/styled';

import { SliderWrapper, Container } from './styled';

const INTERCOM_AUDIO_TARIFF_ID = 154;

class TariffList extends Component {
    static propTypes = {
        tariffs: PropTypes.array,
    };

    tariffCards = [];

    constructor(props) {
        super(props);
        this.state = {
            activeSlide: 0,
            windowWidth: 1990,
        };
        if (process.browser) {
            this.state.windowWidth = window.innerWidth;
        }
        this.list = React.createRef();
    }

    render() {
        const { tariffs } = this.props;

        tariffs.sort((a, b) => a.plan_group_id < b.plan_group_id ? -1 : 1);

        const CustomCounter = (props) => {
            const { active, count, onClick, slidesToShow } = props;
            const dots = [];
            for (let i = 0; i <= count; i++) {
                dots.push(<Dots key={i} active={i === active} onClick={() => onClick(i)}/>);
            }
            return (
                <Wrapper>
                    <DotWrapper>
                        {dots}
                    </DotWrapper>

                    <Counter>
                        {`Показано
                        ${1 + active === 2 ? 'co' : 'c'}
                        ${1 + active} по
                        ${(slidesToShow) + active} тариф из ${tariffs.length}`
                        }
                    </Counter>
                </Wrapper>
            );
        };

        const CustomArrows = (props) => {
            const { swipeLeft, swipeRight } = props;
            return (
                <ArrowWrapper>
                    <LeftArrow type='secondary' onClick={swipeLeft}/>
                    <RightArrow type='secondary' onClick={swipeRight}/>
                </ArrowWrapper>
            );
        };

        const settings = {
            breakpoints: [
                { width: 0, slidesToShow: 1 },
                { width: 765, slidesToShow: 2 },
                { width: 1024, slidesToShow: 3 },
            ]
        };

        const tariffList = tariffs.map(tariff => {
            return (
                <Slide key={tariff.id} >
                    <IntercomTariffCard
                        key={tariff.id}
                        tariff={tariff}
                    >
                        <Option
                            typeOptions='home'
                            headingColor={tariff.headingColor}
                            title='Электронный ключ'
                            value={tariff.key_count}
                            valueText='шт.'
                        />
                        <Option
                            typeOptions='intercom'
                            headingColor={tariff.headingColor}
                            title='Мобильное приложение'
                            valueText={tariff.plan_group_id > 152 ? 'есть' : 'нет'}
                        />
                        {tariff.plan_group_id !== INTERCOM_AUDIO_TARIFF_ID
                            ? <Option
                                typeOptions='phone'
                                headingColor={tariff.headingColor}
                                title='Кол-во смартфонов'
                                valueText={tariff.plan_group_id > 152 ? '∞' : 'нет'}
                            /> : <Option
                                typeOptions='audio'
                                headingColor={tariff.headingColor}
                                title='Аудиотрубка'
                                valueText='есть'
                            />
                        }
                    </IntercomTariffCard>
                </Slide>
            );
        });

        return (
            <React.Fragment>
                <Container>
                    <SliderWrapper>
                        <Carousel visibleCardWidth={1024} responsive={settings.breakpoints} showDots={true}
                                  dots={CustomCounter} arrows={CustomArrows}>
                            {tariffList}
                        </Carousel>
                    </SliderWrapper>
                </Container>
            </React.Fragment>
        );
    }

    componentDidMount() {
        if (process.browser) {
            const alignAfterLoad = () => {
                window.addEventListener('resize', () => {
                    this.setState({ windowWidth: window.innerWidth });
                });
                window.removeEventListener('load', alignAfterLoad);
            };
            window.addEventListener('load', alignAfterLoad);
        }
    }
}

export default TariffList;
